import React, { useState, useEffect } from "react";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import ViewDetails from "./ViewDetails"; // Assuming this is the updated ViewDetails component
import envConfig from "../../config/config";

const ProjectTable = () => {
    const { accounts } = useMsal();
    const email = accounts[0]?.username.toLowerCase() || "";
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedSwaggerId, setSelectedSwaggerId] = useState(null);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [showApiModal, setShowApiModal] = useState(false);
    const [projectStatus, setProjectStatus] = useState('')

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await axios.get(
                    `${envConfig.REACT_APP_APIREPO_READ}/apirepo/v0.1/projects/${email}`
                );
                setProjects(response.data.projects || []);
            } catch (err) {
                console.error("Error fetching projects:", err);
            } finally {
                setLoading(false);
            }
        };

        if (email) {
            fetchProjects();
        }
    }, [email]);

    const formatDate = (date) => {
        const newDate = new Date(date);
        return newDate.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    const openApiModal = (swaggerFileId, projectId, status) => {
        console.log("Status", status)
        setSelectedSwaggerId(swaggerFileId);
        setSelectedProjectId(projectId);
        setShowApiModal(true);
        setProjectStatus(status)
    };

    return (
        <div className="max-w-7xl mx-auto px-4 py-6">
            {loading ? (
                <div className="flex justify-center items-center py-10">
                    <svg
                        className="animate-spin h-8 w-8 text-blue-600"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        />
                    </svg>
                </div>
            ) : (
                <div className="overflow-x-auto border border-gray-300 rounded-lg max-h-[300px] overflow-y-auto">
                    <table className="min-w-full bg-white text-sm text-left">
                        <thead className="bg-gray-100 sticky top-0 z-10">
                            <tr>
                                <th className="p-3">Project Name</th>
                                <th className="p-3">Total APIs</th>
                                <th className="p-3">Status</th>
                                <th className="p-3">Date of Creation</th>
                                <th className="p-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projects?.map((project) => (
                                <tr key={project.projectId} className="border-t">
                                    <td className="p-3 flex items-center space-x-4">
                                        <img
                                            src={project.assets.projectLogoUrl}
                                            alt="Project Logo"
                                            className="h-10 w-10 object-cover rounded-full"
                                        />
                                        <span>{project.projectName}</span>
                                    </td>
                                    <td className="p-3">
                                        {project.apiIds?.length || 0}
                                    </td>
                                    <td className="p-3">
                                        <span
                                            className={`inline-block px-3 py-1 rounded-full text-sm font-semibold
                                                    ${project.status.currentStatus === "incomplete" ? "bg-gray-200 text-gray-800"
                                                    : project.status.currentStatus === "pending" ? "bg-yellow-200 text-yellow-800"
                                                        : project.status.currentStatus === "approve" ? "bg-green-200 text-green-800"
                                                            : project.status.currentStatus === "rejected" ? "bg-red-200 text-red-800"
                                                                : "bg-yellow-200 text-yellow-800"
                                                }`}
                                        >
                                            {project.status.currentStatus}
                                        </span>
                                    </td>

                                    <td className="p-3">
                                        {formatDate(project.dateOfCreation)}
                                    </td>
                                    <td className="p-3">
                                        <button
                                            className="text-blue-600 hover:text-blue-800 underline"
                                            onClick={() => openApiModal(project.assets.files.fileId, project.projectId, project.status.currentStatus)}
                                        >
                                            View Details
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showApiModal && selectedSwaggerId && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white rounded-lg shadow-lg max-w-6xl w-full p-4 relative">


                        {/* Pass 'isEditable' as false to enforce read-only mode */}
                        <ViewDetails
                            swaggerFileId={selectedSwaggerId}
                            projectId={selectedProjectId}
                            projectStatus={projectStatus}
                            isEditable={false} // Force read-only mode
                            setShowApiModal={setShowApiModal}
                            onClose={() => setShowApiModal(false)}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProjectTable;
